// extracted by mini-css-extract-plugin
export default {"launcher":"bb_N1","launcher__heading":"bb_N2","launcher__menu-item":"bb_N3"};